'use strict';

export class ImportPatientDocumentModel {
  constructor(date, description, comment, fileObject, ssn, sdate) {
    this.ssn = ssn;
    this.sdate = sdate
    this.date = date;
    this.description = description;
    this.comment = comment;
    this.file = fileObject.toUpload;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/importPatientDocumentModel.js